import { render } from "./ProductCatalog.vue?vue&type=template&id=412d5cd2"
import script from "./ProductCatalog.vue?vue&type=script&lang=js"
export * from "./ProductCatalog.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__